import { AutocompleteInput, useGetList } from 'react-admin';

const TestimonialCategoryAutoComplete = (props: any) => {
    const { data, isLoading } = useGetList(
        'testimonial-category',
        {
            pagination: { page: 1, perPage: 50 },
            filter: { deleted: false },
        },
        {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    );

    return (
        <AutocompleteInput
            {...props}
            source="categoryId"
            label="Testimonial Category"
            choices={data || []}
            optionText="name"
            optionValue="id"
            loading={isLoading}
        />
    );
};

export default TestimonialCategoryAutoComplete;
